import { pluginFactory } from '@atlaskit/editor-common/utils';
import type { EditorState, ReadonlyTransaction } from '@atlaskit/editor-prosemirror/state';

import {
	canSplitParagraphIntoSentences,
	getAllProactiveAIBlocks,
} from '../ai-spelling-grammar/utils';

import { aiSGTrafficProjectionsPluginKey } from './ai-sg-traffic-projections-plugin-key';
import { reducer } from './reducer';
import type { AISGBetterTrafficProjectionsPluginState } from './types';
import { findProactiveAIBlockToUpdate } from './utils';

const handleDocChanged = (
	tr: ReadonlyTransaction,
	pluginState: AISGBetterTrafficProjectionsPluginState,
	newEditorState: EditorState,
): AISGBetterTrafficProjectionsPluginState => {
	const { updatedProactiveAIBlock } = findProactiveAIBlockToUpdate(tr, pluginState, newEditorState);

	return {
		...pluginState,
		proactiveAIBlocks: updatedProactiveAIBlock,
	};
};

export const createInitialState = (state: EditorState) => {
	const { proactiveAIBlocks } = getAllProactiveAIBlocks(state);
	return {
		proactiveAIBlocks,
		splitParagraphIntoSentences: canSplitParagraphIntoSentences(),
		totalRequests: 0,
		partLengths: [],
		durationBetweenRequests: [],
		partsPerRequests: [],
		lastRequestTime: 0,
	};
};

export const { createPluginState, createCommand, getPluginState } = pluginFactory(
	aiSGTrafficProjectionsPluginKey,
	reducer,
	{
		onDocChanged: handleDocChanged,
	},
);
